export var OrganizationIdentifierScheme;
(function (OrganizationIdentifierScheme) {
    OrganizationIdentifierScheme["DK_CVR"] = "DK:CVR";
    OrganizationIdentifierScheme["DK_CPR"] = "DK:CPR";
    OrganizationIdentifierScheme["NO_ORG"] = "NO:ORG";
    OrganizationIdentifierScheme["NO_ORGNR"] = "NO:ORGNR";
    OrganizationIdentifierScheme["SE_ORGNR"] = "SE:ORGNR";
    OrganizationIdentifierScheme["GLN"] = "GLN";
})(OrganizationIdentifierScheme || (OrganizationIdentifierScheme = {}));
//# sourceMappingURL=types.js.map